import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "button", "dropdown", "display"]

  connect() {
    // Close dropdown when clicking outside
    this.clickOutside = this.clickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutside)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.dropdownTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.dropdownTarget.classList.remove("hidden")
    document.addEventListener("click", this.clickOutside)
  }

  close() {
    this.dropdownTarget.classList.add("hidden")
    document.removeEventListener("click", this.clickOutside)
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  selectCategory(event) {
    event.preventDefault()
    const button = event.currentTarget
    const categoryId = button.dataset.categoryId
    const categoryName = button.dataset.categoryName
    const categoryColor = button.dataset.categoryColor

    // Update the hidden select
    this.selectTarget.value = categoryId

    // Update the display
    this.displayTarget.innerHTML = `
      <div class="w-3 h-3 rounded-full flex-shrink-0" style="background-color: ${categoryColor}"></div>
      <span>${categoryName}</span>
    `

    // Close the dropdown
    this.close()

    // Trigger change event on the select to notify inline-edit controller
    const changeEvent = new Event('change', { bubbles: true })
    this.selectTarget.dispatchEvent(changeEvent)
  }
}